
import { Component, OnInit, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { catchError, of, tap } from 'rxjs';
import { ActiverUtilisateursModel } from 'src/models/pilotage/activerUtilisateursModel';
import { UtilisateurPilotageModel } from 'src/models/pilotage/utilisateurPilotageModel';
import { UtilisateurService } from 'src/services/utilisateur.service';

@Component({
    selector: 'app-choix-entite-activer-dialog',
    templateUrl: './choix-entite-activer-dialog.component.html',
    styleUrls: ['./choix-entite-activer-dialog.component.scss'],
    imports: [TranslateModule, MatDialogModule, MatSelectModule, MatOptionModule, FormsModule, MatFormFieldModule]
})
export class ChoixEntiteActiverDialogComponent implements OnInit {

  entites: any[] = [];
  entiteSelectionnee: any;
  utilisateurId: number;
  invitationRequise: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ChoixEntiteActiverDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { utilisateur: UtilisateurPilotageModel, invitationRequise?: boolean },
    private utilisateurService: UtilisateurService,
    private snackBar: MatSnackBar
  ) {
    this.utilisateurId = data.utilisateur.utilisateurId;
    this.invitationRequise = data.invitationRequise ?? false;
  }

  ngOnInit(): void {
    this.entites = this.utilisateurService.contexteUtilisateur.entitesAccessibles.filter(e => !e.estGroupe);
  }

  onSelectionnerEntite(): void {
    const selectedEntiteId = this.entites.length > 1 ? this.entiteSelectionnee.entiteId : this.entites[0].entiteId;

    if (this.invitationRequise) {
      // Invitation + Activation
      this.utilisateurService.inviterEtActiverUtilisateurExistant(this.utilisateurId, selectedEntiteId)
        .pipe(
          tap(() => {
            this.snackBar.open('L\'invitation et l\'activation de ' + this.data.utilisateur.email + ' ont été effectuées avec succès', 'Fermer', {
              duration: 5000
            });
            this.dialogRef.close(true);
          }),
          catchError(() => {
            this.snackBar.open('Une erreur est survenue lors de l\'invitation et de l\'activation', 'Fermer', {
              duration: 5000
            });
            return of(null);
          })
        ).subscribe();
    } else {
      // Activation seule
      const activerUtilisateursModel: ActiverUtilisateursModel = {
        utilisateursIds: [this.utilisateurId],
        entiteId: selectedEntiteId
      };

      this.utilisateurService.activerUtilisateurs(activerUtilisateursModel)
        .pipe(
          tap(() => {
            this.snackBar.open('L\'activation de ' + this.data.utilisateur.email + ' a été effectuée avec succès', 'Fermer', {
              duration: 5000
            });
            this.dialogRef.close(true);
          }),
        ).subscribe();
    }
  }

}
